import { validateIdentity, validateContact, validateAbout } from "@/features/identity/validation";
import { IdentitySection } from "@/features/identity/components/IdentitySection";
import { ContactSection } from "@/features/identity/components/ContactSection";
import { AboutSection } from "@/features/identity/components/AboutSection";

const str = (v) => v ?? "";
const optional = (v) => v.trim() || null;

export const SECTIONS = {
  identity: {
    key: "identity",
    title: "Identity",
    description: "Your name and role, exactly as you'd like to be introduced.",
    fromProfile: (p) => ({
      full_name: str(p.full_name),
      professional_title: str(p.professional_title),
      company_name: str(p.company_name),
    }),
    toPatch: (v) => ({
      full_name: v.full_name.trim(),
      professional_title: v.professional_title.trim(),
      company_name: optional(v.company_name),
    }),
    validate: validateIdentity,
    Component: IdentitySection,
  },
  contact: {
    key: "contact",
    title: "Contact",
    description: "How people can reach you. Your sign-in email is not affected.",
    fromProfile: (p, user) => ({ email: p.email || user?.email || "", phone: str(p.phone), website: str(p.website) }),
    toPatch: (v) => ({ email: v.email.trim(), phone: optional(v.phone), website: optional(v.website) }),
    validate: validateContact,
    Component: ContactSection,
  },
  about: {
    key: "about",
    title: "About",
    description: "A short bio people will read first. Up to 500 characters.",
    fromProfile: (p) => ({ bio: str(p.bio) }),
    toPatch: (v) => ({ bio: optional(v.bio) }),
    validate: validateAbout,
    Component: AboutSection,
  },
};
